declare namespace $ {

	export class $shm_hitalama_agent_general extends $shm_hitalama_agent_map_chat {
		map_id( ): string
		project_id( ): string
	}
	
}

//# sourceMappingURL=general.view.tree.d.ts.map